import { request } from "@/utils/request";

/**
 * 查询工具平台付款订单
 * @param {*} data
 * @returns
 */
export function selectOrder(data) {
  return request({
    url: `/admin/mini/order/select`,
    method: "POST",
    data,
  });
}
